import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CustomSelect from "../CustomComponents/CustomSelect";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';


export default function SiteDialog({ handleSiteDialogCallback }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const currencyRegEx = /^(?!0\.00)\d{1,3}(,\d{3})*(\.\d\d)?$/;

    const initialValues = {
        Name: '',
        Location: '',
        Address: '',
        isActive: false
    };

    const validFormSchema = Yup.object({
        Name: Yup
            .string('Enter a long name for this SOW')
            .required('Long name is required'),
        Location: Yup
            .string('Enter a region/country for this cost center')
            .required('Cost Center Location is required'),
        Address: Yup
            .string('Enter an address for this cost center')
            .required('Cost Center Address is required'),
        isActive: Yup
            .boolean()
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            Name: values.Name,
            Location: values.Location,
            Address: values.Address,
            IsActive: values.isActive
        };

        handleSiteDialogCallback(msg);
        handleClose();
    })

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    React.useEffect(() => {

        if (refresh) {
            setRefresh(false);
        }

    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Add Site
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">

                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Add Site
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>Site Info:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="Name"
                                            variant="outlined"
                                            id="Name"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="Name"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="Location"
                                            variant="outlined"
                                            id="outlined-Location"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Location}
                                            error={props.touched.Location && Boolean(props.errors.Location)}
                                            helperText={props.touched.Location && props.errors.Location}
                                            label="Location"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 420 }}>
                                        <TextField
                                            name="Address"
                                            variant="outlined"
                                            id="outlined-Address"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Address}
                                            error={props.touched.Address && Boolean(props.errors.Address)}
                                            helperText={props.touched.Address && props.errors.Address}
                                            label="Address"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1 }}>
                                        <FormControlLabel
                                            label="Active"
                                            control={<Checkbox name="isActive" checked={props.values.isActive} onChange={props.handleChange} />}
                                        />
                                    </FormControl>
                                </div>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
            </Dialog>
        </div>
    );
}